














































import {Component, Prop} from 'vue-property-decorator'
import {Contract} from '@/model/resource/Contract'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import NetworkTag from '@/components/NetworkTag.vue'

@Component({
  components: {NetworkTag},
})
export default class ContractDappCellRender extends MixinScreenSize {
  @Prop({type: Object, required: true}) contract!: Contract
}
